import { TranslateService } from '@ngx-translate/core';
import { Component, ViewChild } from '@angular/core';
import { LoadingController, ModalController, NavController, NavParams, ToastController } from 'ionic-angular';
import { Globals } from "../../../../../globals";
import { DeliberyNoteServices } from "../../../services";
import { ColumnMode, DatatableComponent } from '@swimlane/ngx-datatable';
import { CompCreateProductPage } from '../../../../components/popups/create-product/create-product';
import { CompCreateIngredientPage } from '../../../../components/popups/create-ingredient/create-ingredient';
/**
 * Generated class for the DeliberyNoteCreatePartialIngprodSelectPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-delibery-note-create-partial-ingprod-select',
  templateUrl: 'delibery-note-create-partial-ingprod-select.html',
})
export class DeliberyNoteCreatePartialIngprodSelectPage {
  term: string;
  //datatable
  sorts = [
    { prop: 'name', dir: 'asc' }
  ];
  @ViewChild(DatatableComponent) table: DatatableComponent;
  ColumnMode = ColumnMode;
  config_msg = {
    emptyMessage: this.translate.instant('general-no-hay-datos'),
    totalMessage: this.translate.instant('general-total'),
    selectedMessage: this.translate.instant('general-seleccionado')
  };
  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public loadingCtrl: LoadingController,
    private toastCtrl: ToastController,
    public globals: Globals,
    public deliberyNoteServices: DeliberyNoteServices,
    public translate: TranslateService,
    public modalCtrl: ModalController) {
  }

  ionViewWillEnter() {
  }

  insert(proding) {

    if (!this.check(proding.UID)) { //Buscamos si el ingrediente o producto ya esta anadido
      var message = this.translate.instant('general-producto') + ' ' + this.globals.nameLangSelectProduct(proding) + ' ' + this.translate.instant('instant-anadido-correctemente');
      var _array = Array();
      _array.push(proding.UID);
      if (proding.type === 'product') {
        _array.push(this.globals.nameLangSelectProduct(proding));
      } else {
        _array.push(proding.name);
      }
      _array.push(proding.type);
      _array.push(proding.price_static);
      _array.push(proding.measurement);

      if (proding.providers && proding.providers.length > 0) {
        for (let entry of proding.providers) {
          if (entry.default) {
            _array.push(entry.tax_static);
          }
        }
      } else {
        _array.push(0);
      }
      _array.push(0);
      _array.push(0);
      _array.push(0);
      if (proding.type === 'product') {
        _array.push(proding.pvp);
      } else {
        message = this.translate.instant('general-ingrediente') + ' ' + proding.name + ' ' + this.translate.instant('instant-anadido-correctemente');
        _array.push(0);
      }
      _array.push(0); //total_sin_iva
      _array.push(''); //lots
      _array.push('discount_percentage'); //discount type
      this.deliberyNoteServices.prodings_array_tmp.push(_array);
      this.deliberyNoteServices.prodings_array_tmp = [...this.deliberyNoteServices.prodings_array_tmp];

      let toast = this.toastCtrl.create({
        message: message,
        duration: 3000,
        position: 'bottom'
      });
      toast.present();

    } else {
      // Mensaje mejorado mostrando el nombre del elemento
      const elementName = proding.type === 'product' 
        ? this.globals.nameLangSelectProduct(proding) 
        : proding.name;
      
      let toast = this.toastCtrl.create({
        message: `"${elementName}" ${this.translate.instant('instant-ingrediente-producto-esta-anadido-lista')}`,
        duration: 3000,
        position: 'bottom',
        cssClass: 'toast-warning'
      });
      toast.present();
    }
  }

  check(value) {
    // Método optimizado y más robusto para verificar duplicados
    return this.deliberyNoteServices.prodings_array_tmp.some(item => item[0] === value);
  }

  nextPage() {
    if (this.deliberyNoteServices.page_active < this.deliberyNoteServices.pagesIngredientsProducts.length) {
      this.deliberyNoteServices.page_active += 1
    }
    this.deliberyNoteServices.getListIngredientsProductsMinMax();
  }
  previusPage() {
    if (this.deliberyNoteServices.page_active > 1) {
      this.deliberyNoteServices.page_active -= 1;
    }
    this.deliberyNoteServices.getListIngredientsProductsMinMax();
  }
  activePage(number) {
    this.deliberyNoteServices.page_active = number;
    this.deliberyNoteServices.getListIngredientsProductsMinMax();
  }
  clickElement(event) {
    if (event.type == 'click') {
      this.insert(event.row);
    }
  }
  createProduct() {
    //open create product
    let profileModal = this.modalCtrl.create(CompCreateProductPage, {
      origin: 'delibery-note'
    });
    profileModal.present();
  }

  createIngredient() {
    //open create ingredient
    let profileModal = this.modalCtrl.create(CompCreateIngredientPage, {
      origin: 'delibery-note'
    });
    profileModal.present();
  }
}



// WEBPACK FOOTER //
// ./src/pages/delibery_note/delibery-note-create/delibery-note-create-select-ingprod/delibery-note-create-partial-ingprod-select/delibery-note-create-partial-ingprod-select.ts